import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { APP_SETTINGS } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { UserProfileService } from '../user-profile.service';
import { NgIf, NgFor, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-manage-devices',
    templateUrl: './manage-devices.component.html',
    styleUrls: ['./manage-devices.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgFor,
        RouterLink,
        NgStyle,
    ],
})
export class ManageDevicesComponent implements OnInit, OnDestroy {

  private subscriptions: ISubscription[];
  userDevicesInfo: any[];

  screenWidth: number;
  APP_SETTINGS: any;
  username: string;

  constructor(private userProfileService: UserProfileService,
    private authService: AuthService,
    private utilityService: UtilityService) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.username = this.authService.getUserName();
    this.subscriptions = [];
    this.subscriptions.push(this.userProfileService.getAllUserDevicesInfo(this.username).subscribe(data => {
      this.userDevicesInfo = data;
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe());
  }


}
